import ALLOWED_QUERY_KEYS from "../constants/queryKeys.js";
import extractFields from "./extractFields.js";

const buildQuery = (query = {}) => {
  const sanitizedQuery = extractFields(query, ALLOWED_QUERY_KEYS);
  if (!Object.keys(sanitizedQuery).length) return "";

  const params = new URLSearchParams();

  Object.entries(sanitizedQuery).forEach(([key, value]) => {
    params.append(key, String(value));
  });

  return `?${params.toString()}`;
};

export default buildQuery;
